<template>
  <!-- Opens the task the user closed last, on the page they are on (replaces the task docked in the lower left corner) -->
  <div v-if="lastTask">
    <button type="button"
            class="sb-item sb-item--last-task"
            :disabled="opening"
            :aria-label="compact ? $t('app_nav.reopen_task') + ': ' + title : null"
            @click="open"
            qid="side-nav-reopen-task"
    >
      <font-awesome-icon :icon="opening ? 'spinner' : 'rotate-left'" class="sb-item__icon" :class="{'fa-spin': opening}"/>
      <span class="sb-item__text">
        {{ $t('app_nav.reopen_task') }}
        <span class="sb-item__sub">{{ title }}</span>
      </span>
    </button>

    <!-- The task modals, as on Home; only their dialogs are shown -->
    <AssessmentTaskModal
        ref="assessmentTaskModal"
        :task="task"
        :tasks="task && task.project ? task.project : {}"
        :fromHomepage="true"
        style="display:none;"
    />
    <AssessmentGlobalSingleTaskModal
        ref="assessmentGlobalTaskModal"
        :task="task"
        :tasks="task && task.project ? task.project : {}"
        :fromHomepage="true"
        :panel="isEngagement(task && task.project)"
        style="display:none;"
    />
    <RiskTaskModal
        ref="riskTaskModal"
        :task="task"
        :tasks="task && task.project ? task.project : {}"
        :fromHomepage="true"
        style="display:none;"
    />
    <UpdateTaskModal
        ref="updateTaskModal"
        :task="task"
        :tasks="task && task.project ? task.project : {}"
        :fromHomepage="true"
        style="display:none;"
    />
    <ValidationTaskModal
        ref="validationTaskModal"
        :task="task"
        :tasks="task && task.project ? task.project : {}"
        :fromHomepage="true"
        style="display:none;"
    />
  </div>
</template>

<script>
import piincHttp from '@/util/configureAxios.js';
import AssessmentTaskModal from '@/views/Tasks/AssessmentTaskModal.vue';
import AssessmentGlobalSingleTaskModal from '@/views/Tasks/AssessmentGlobalSingleTaskModal.vue';
import RiskTaskModal from '@/views/Tasks/RiskTaskModal.vue';
import UpdateTaskModal from '@/views/Tasks/UpdateTaskModal.vue';
import ValidationTaskModal from '@/views/Tasks/ValidationTaskModal.vue';
import { isEngagement } from '@/views/Projects/Engagement/engagement.js';

// Which modal opens a task, by project type
const MODALS = {
  risk_assessment: 'assessmentTaskModal',
  bia_assessment: 'assessmentTaskModal',
  control_assessment: 'assessmentGlobalTaskModal',
  control: 'riskTaskModal',
  security_measure: 'riskTaskModal',
  update: 'updateTaskModal',
  validation: 'validationTaskModal'
};

export default {
  name: 'LastTaskButton',
  components: {
    AssessmentTaskModal,
    AssessmentGlobalSingleTaskModal,
    RiskTaskModal,
    UpdateTaskModal,
    ValidationTaskModal
  },
  props: {
    compact: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      task: {},
      opening: false
    };
  },
  computed: {
    getClient() {
      return this.$store.state.client;
    },
    // Only tasks of the client the user is working in
    lastTask() {
      const last = this.$store.state.lastClosedTask;
      if (!last || !MODALS[last.project_type] || !this.getClient) {
        return null;
      }
      const client = last.client && last.client.slug ? last.client.slug : last.client;
      return !client || client === this.getClient.slug ? last : null;
    },
    title() {
      const last = this.lastTask;
      if (!last) {
        return '';
      }
      if (last.project_type === 'update' || last.project_type === 'validation') {
        const key = 'tasks.values.' + this.$options.filters.slugify(last.title || '');
        return this.$te(key) ? this.$t(key) : last.title;
      }
      return last.title;
    }
  },
  methods: {
    isEngagement(project) {
      return isEngagement(project);
    },
    open() {
      const last = this.lastTask;
      if (!last || this.opening) {
        return;
      }
      this.opening = true;
      piincHttp.get('tasks/' + last.id).then(response => {
        this.opening = false;
        const task = response.data;
        if (!task || !task.id || !task.project) {
          return;
        }
        this.task = task;
        this.$nextTick(() => {
          const modal = this.$refs[MODALS[task.project.type]];
          if (modal && typeof modal.showTaskModal === 'function') {
            modal.showTaskModal(task);
          }
        });
      }, () => {
        this.opening = false;
      });
    }
  }
};
</script>
